import { render, staticRenderFns } from "./DetailPageTabsStep.vue?vue&type=template&id=0577c8dc&scoped=true"
import script from "./DetailPageTabsStep.vue?vue&type=script&lang=js"
export * from "./DetailPageTabsStep.vue?vue&type=script&lang=js"
import style0 from "./DetailPageTabsStep.vue?vue&type=style&index=0&id=0577c8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0577c8dc",
  null
  
)

export default component.exports